<ng-container *ngIf="!isMobile; else mobile">
  <ng-container *ngIf="isBookingRoute; else rightRepentance">
    <app-modal>
      <ng-container content>
        <ng-container *ngTemplateOutlet="rightRepentance"></ng-container>
      </ng-container>
    </app-modal>
  </ng-container>

</ng-container>

<ng-template #mobile>
  <ng-container *ngTemplateOutlet="rightRepentance"></ng-container>
</ng-template>

<ng-template #rightRepentance>
  <div class="route-cont" [class.no-booking]="!isBookingRoute" [class.{{animation}}]="isMobile"
    [class.animated]="isMobile">
    <div class="content-right-repentance">
      <div class="box-content">
        <div *ngIf="!isMobile">
          <span class="title">{{'RIGHT_REPENTACE_MODULE.TITLE' | transloco | uppercase}}</span>
        </div>
        <ng-container>
          <p>
            Mediante esta opción podrás ejercer tu derecho de arrepentimiento sobre compras realizadas dentro de los 10 días corridos de realizada la misma. 
          </p>

          <p>
            Recordá que esto no aplica para la compra de vuelos conforme Resolución ANAC 329/2020. 
          </p>

          <p>
            <strong>Procedimiento:</strong>
          </p>
          <ol>
            <li>
              El Usuario Consumidor: podrá ejercer su derecho <strong>dentro de los 10 (DIEZ) días corridos</strong> contados a partir 
              de la <strong>fecha en que se entregue el bien o se celebre el contrato,</strong> lo último que ocurra, sin responsabilidad alguna. 
            </li>
            <li>
              Dentro de las <strong>24 horas siguientes</strong> y por el mismo medio en que procedió el derecho de revocación, 
              Rappi deberá <strong>informar al consumidor el código de identificación</strong> del arrepentimiento o revocación, 
              en caso que corresponda, teniendo en cuenta los excluyentes.
            </li>
            <li>Se deberá resolver la situación dentro de los plazos previstos en la Ley de Defensa del Consumidor.</li>
          </ol>

          <p>
            Para mayor información podés consultar en la 
            <a target="_blank" rel="noopener" href="https://servicios.infoleg.gob.ar/infolegInternet/anexos/0-4999/638/texact.htm">Ley de Defensa del Consumidor N°24.240</a>, 
            los artículos 1110 y 1112 del 
            <a target="_blank" rel="noopener" href="https://servicios.infoleg.gob.ar/infolegInternet/anexos/235000-239999/235975/norma.htm#21">Código Civil y Comercial de la Nación Argentina</a>, 
            <a target="_blank" rel="noopener" href="https://www.boletinoficial.gob.ar/detalleAviso/primera/235729/20201005?busqueda=1">Resolución 424/2020</a> 
            emitida por la Secretaría de Comercio Interno, <a target="_blank" href="https://www.boletinoficial.gob.ar/detalleAviso/primera/238219/20201210?busqueda=1">Resolución 329/2020</a>
            de la Administración Nacional de Aviación Civil y complementarias. 
          </p>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>
